<template>
  <v-container v-if="$can('browse', 'YachtType')">
    <!--<editor-fold desc="Page header">-->
    <v-row

      align="center"
      class="mb-12"
    >
      <v-col>
        <div class="headline">
          Yacht Types
        </div>
      </v-col>
      <v-col class="shrink">
        <v-btn
          v-if="$can('create', 'YachtType')"
          color="primary"
          class="ma-0"
          @click="openYachtTypesEditDialog()"
        >
          <v-icon left>
            add
          </v-icon>
          Add New
        </v-btn>
      </v-col>
    </v-row>
    <!--</editor-fold>-->

    <v-row>
      <v-col
        cols="3"
      >
        <v-subheader class="justify-space-between pr-0">
          Filters
          <v-btn
            v-if="isFiltered"
            text
            color="red"
            @click="clearFilters"
          >
            <v-icon
              small
              left
            >
              close
            </v-icon>
            Clear
          </v-btn>
        </v-subheader>
        <v-text-field
          v-model="filtersDirty.label"
          solo
          label="Label"
          hide-details
          clearable
          class="mb-2"
          autocomplete="no"
        />
      </v-col>
      <v-col cols="13">
        <!--<editor-fold desc="Pagination header">-->
        <pagination
          :from="yachtTypes.meta.from"
          :to="yachtTypes.meta.to"
          :total="yachtTypes.meta.total"
          :last-page="yachtTypes.meta.last_page"
          :page.sync="pagination.page"
          class="mb-1 align-end"
        />
        <!--</editor-fold>-->
        <!--<editor-fold desc="Table">-->
        <v-data-table
          :headers="headers"
          :items="yachtTypes.data"
          :loading="yachtTypes.loading"
          :page.sync="pagination.page"
          :sort-by.sync="sorting.sortBy"
          :sort-desc.sync="sorting.desc"
          :server-items-length="yachtTypes.meta.total"
          hide-default-footer
          class="elevation-5"
        >
          <template v-slot:item="{ item }">
            <yacht-type-row
              :yacht-type="item"
              @click.native="openYachtTypesEditDialog(item)"
            />
          </template>
          <template slot="no-data">
            <!--<editor-fold desc="Filtered">-->
            <v-row
              v-if="isFiltered"

              class="text-center py-2"
            >
              <v-col cols="16">
                There are no results for your search..
              </v-col>
              <v-col
                cols="16"
                class="mt-2"
              >
                <v-btn
                  class="ma-0"
                  small
                  text
                  @click="clearFilters()"
                >
                  <v-icon left>
                    clear
                  </v-icon>
                  Clear Filters
                </v-btn>
              </v-col>
            </v-row>
            <!--</editor-fold>-->
            <!--<editor-fold desc="NoData">-->
            <v-row
              v-else

              class="text-center py-2"
            >
              <v-col cols="16">
                There are no yacht types at the moment.
              </v-col>
              <v-col
                cols="16"
                class="mt-2"
              >
                <v-btn
                  v-if="$can('create', 'YachtType')"
                  color="primary"
                  class="ma-0"
                  small
                  @click="openYachtTypesEditDialog()"
                >
                  <v-icon left>
                    add
                  </v-icon>
                  Add New
                </v-btn>
              </v-col>
            </v-row>
            <!--</editor-fold>-->
          </template>
          <table-footer
            slot="footer"
            :last-page="yachtTypes.meta.last_page"
            :page.sync="pagination.page"
          />
        </v-data-table>
        <!--</editor-fold>-->
      </v-col>
    </v-row>

    <yacht-type-edit-dialog
      :visible.sync="yachtTypeEditDialog"
      :yacht-type="yachtTypeDirty"
      @update:yachtType="fetchYachtTypes"
    />
  </v-container>
</template>

<script>
  import { cloneDeep } from 'lodash'
  import paginationMixin from '@/mixins/paginationMixin'
  import filterableMixin from '@/mixins/filterableMixin'
  import YachtType from '@/models/YachtType'
  import YachtTypeRow from '@/components/settings/yachtTypes/YachtTypeRow'
  import YachtTypeEditDialog from '@/components/settings/yachtTypes/YachtTypeEditDialog'
  import TableFooter from '@/components/helpers/TableFooter'

  export default {
    name: 'YachtTypesIndex',
    components: {
      YachtTypeRow,
      YachtTypeEditDialog,
      TableFooter
    },
    mixins: [paginationMixin, filterableMixin],
    data() {
      return {
        yachtTypes: {
          data: [],
          loading: false,
          meta: {}
        },
        headers: [
          { text: 'Label', value: 'label', sortable: true }
        ],
        yachtTypeDirty: null,
        yachtTypeEditDialog: false,
        filtersClean: YachtType.emptyFilters,
        filtersDirty: cloneDeep(YachtType.emptyFilters)
      }
    },
    created() {
      this.fetchYachtTypes()
    },
    methods: {
      onPaginationUpdate() {
        this.fetchYachtTypes()
      },
      onFiltersUpdate() {
        this.resetPagination()
      },
      async fetchYachtTypes() {
        this.yachtTypes.loading = true

        let queryParams = {
          ...this.paginationQueryParams,
          ...this.filterQueryParams
        }

        try {
          let result = await YachtType.api.fetch(queryParams)

          this.yachtTypes.data = result.data
          this.yachtTypes.meta = result.meta
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.yachtTypes.loading = false
        }
      },
      openYachtTypesEditDialog(yachtType = YachtType.emptyModel) {
        this.yachtTypeDirty = cloneDeep(yachtType)
        this.yachtTypeEditDialog = true
      },
      clearFilters() {
        this.filters = cloneDeep(YachtType.emptyFilters)
      }
    }
  }
</script>
